import { Component, Input } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'app-tooltip-icon',
  templateUrl: './tooltip-icon.component.html',
  styleUrls: ['./tooltip-icon.component.scss'],
})
export class TooltipIconComponent {
  @Input() icon = 'info';
  @Input() type = 'info';
  @Input() iconClass = "";

  isOpen = false;

  // prefer above the icon, fall back to below when there isn't room
  positions: ConnectedPosition[] = [
    {originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -6},
    {originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 6},
  ];
}
